module.exports = __webpack_public_path__ + "img/icon_sel@2x.1c11d272.png";